import { Grid2 } from "@mui/material";
import cn from 'classnames';

import classes from './index.module.scss';

const PageLayout = ({ header, center, footer, showHorizontalScroll = false }) => {
  return (
    <Grid2
      container
      direction='column'
      className={classes.body}
    >
      {
        header ? (<Grid2 size={12} className={classes.shrink}>{header}</Grid2>) : null
      }
      {
        center ? (
          <Grid2
            size={12}
            className={
              cn(classes.fullHeight,
                {
                  [ classes.showHorizontalScroll ]: !!showHorizontalScroll
                }
              )}
          >
            {center}
          </Grid2>) : null
      }
      {
        footer ? (<Grid2 size={12} className={classes.shrink}>{footer}</Grid2>) : null
      }
    </Grid2>
  )
}

export default PageLayout;